import React from 'react';
import ReactDOM from 'react-dom';
import ConfigUI from './index';
import formatMessage from './lang';
let _dialog = {};
const _render = (id, config) => {
    let _tempDialog = null;
    const ref = (dialog) => {
        _tempDialog = _dialog[id] = {
            open: dialog.open.bind(dialog),
            show: dialog.show.bind(dialog),
            close: dialog.close.bind(dialog),
        };
    };
    const cmp = React.createElement(ConfigUI, { config, formatMessage, ref });
    const container = document.createElement('section');
    container.setAttribute('id', id);
    document.body.appendChild(container);
    ReactDOM.render(cmp, container);
    return _tempDialog;
};
const dialog = (id, config, show = true) => {
    let dialog = _dialog[id];
    if (!dialog) {
        const temp = _render(id, config);
        if (!temp) {
            return;
        }
        dialog = temp;
    }
    if (show === true) {
        dialog.open(config);
    }
    return dialog;
};
export default dialog;
